import Particle from "./Particle";
import AbstractParticles from "./AbstractParticles";

class TwinParticles extends AbstractParticles {
  // ---------------------------------------------------------------------------
  // --	TwinParticles
  // ---------------------------------------------------------------------------

  constructor() {
    super(".js-bg-twin-marker");

    //小さいパーティクル
    this.particleS = new Particle();
    this.particleS.setScaleByPX(94);
    this.particleS.alpha = 0.6;
    this.particleS.randomMove(60, 180);
    this.container.addChild(this.particleS);

    //大きいパーティクル
    this.particleL = new Particle();
    this.particleL.setScaleByPX(204);
    this.particleL.alpha = 0.7;
    this.particleL.randomMove(30, 90);
    this.container.addChild(this.particleL);
  }

  // ---------------------------------------------------------------------------
}

export default TwinParticles;
